export default {
  "Connect Wallet":"ウォレット接続",
  "Loading":"読み込み中...",
  "Purchase Quantity": "購入数量",
  "Total Amount": "総額",
  "Payment Method": "お支払い方法",
  "Fee": "手数料",
  "Purchase": "購入",
  "Select Payment Method": "お支払い方法の選択",
  "Language Switch": "言語スイッチ",
  "Mall": "モール",
  "STAR Purchase": "STAR購入",
  "Order Details": "注文詳細",
  "My Orders": "私の注文",
  "Order Confirmation Page": "注文確認ページ",
  "Product Details": "商品詳細",
  "Store Details": "ストア詳細",
  "Staking MUSE":"ステーキング MUSE",
  "My Stake":"私の賭け",
  "Redeemable Time":"償還可能時間",
  "Redeem":"償還する",
  "Stake":"賭ける",
  "How to Obtain MUSE":"MUSEの入手方法",
  "Activity Rules":"アクティビティルール",
  "Stake Amount":"賭け金額",
  "Please Enter Amount":"金額を入力してください",
  "Balance":"残高",
  "Redeem Amount":"償還金額",
  "Confirm":"確認する",
  "Cancel":"キャンセルする",
  "Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.":"MUSE をステーキングすると、StarNest プラットフォーム上のアクティビティに対する投票力が高まり、お気に入りの参加者に投票できるようになります。",
  "Rule1":"1. MUSEをステーキングすることで、StarNestプラットフォーム活動の投票権を増やすことができます（対応する活動の説明を参照してください）。",
  "Rule2":"2. 担保されたMUSEは、投資活動の終了後いつでも償還できます。",
  "Rule3":"3. MUSEをステーキングすることで、プラットフォームのガバナンスやその他の活動にも参加できます。",
  "Rule4":"4. 最終的な解釈権はStarNestプラットフォームにあります。",
  "Staked":"杭打ち",
  "Redeemed":"償還されました",
  "Payment":"支払い",
  "Next step":"次のステップ",
  "Amount":"金額",
  "Copied":"コピーされました",
  "QRCodeTip":"QR コードをスキャンするか、アドレスをコピーして注文金額をお支払いください。支払い金額が不十分な場合、注文は失敗し、返金は行われません。",
  "Scan QR code to pay":"QR コードをスキャンして支払い",
  "DownloadTip":"QR コードをスキャンして StarNest アプリをダウンロードし、今すぐ体験してください",
  "Save QR code":"QRコードを保存",
  "Minimum":"最小",
  "All":"すべて",
  "Failed to create order":"注文の作成に失敗しました",
  "The order was created successfully and payment is being redirected":"注文は正常に作成され、支払いはリダイレクトされます",
  "Payment details":"支払い詳細",
  "Address management":"アドレス管理",
  "New address":"新しいアドレス",
  "Delete address":"アドレスを削除",
  "Are you sure you want to delete this address?":"このアドレスを削除してよろしいですか?",
  "First name":"姓氏",
  "Last name":"名前",
  "Please enter":"入力してください",
  "Phone":"電話番号",
  "Country":"国",
  "State/Province":"都道府県",
  "City":"市",
  "Address":"住所",
  "Zip code":"郵便番号",
  "Email":"メール",
  "Save address":"アドレスを保存",
  "The address has been edited, do you want to save it?":"アドレスが編集されました。保存しますか?",
  "Return":"戻る",
  "Save":"保存",
  "Waiting for payment":"支払い待ち",
  "Please complete the payment within time as soon as possible":"できるだけ{time}内に支払いを完了してください",
  "Expired":"有効期限切れ",
  "Order ID":"注文ID",
  "Order total":"注文合計",
  "Order time":"注文時刻",
  "Payment method":"支払方法",
  "Billing address":"請求先住所",
  "Switch address":"住所を変更",
  "Pay":"支払う",
  "Deleted":"削除済み",
  "Please fill in the form completely":"フォームを完全に入力してください",
  "Create success":"作成に成功しました",
  "Update success":"変更成功",
  "Insufficient balance":"残高不足",
  "No address filled in yet":"まだアドレスが入力されていません",
  "Choose country":"国を選択する",
  "Please enter search keywords":"検索キーワードを入力してください",
  "Payment successful":"支払いが成功しました",
  "Please check the balance in your wallet":"ウォレットの残高を確認してください",
  "Finish":"完了",
  "Payment failed":"支払いに失敗しました",
  "Please complete the payment in time in My Order-Waiting for Payment":"注文-支払待ちの中で、期限内に支払いを完了してください",
  "Uploading":"アップロード中",
  "Upload payment voucher":"支払い証明書をアップロード",
  "Submission successful, please check the order later":"提出が成功しました。後で注文を確認してください",
  "Confirm submission":"提出を確認する",
  "Rate tip":"支払い方法によって、料金に為替レートの差が生じる可能性があり、最終的な支払い金額が基準となります。",
  "Please log in":"ログインしてください",
  "Insufficient product inventory":"商品の在庫が不足しています",
  "Showtime":"公演時間",
  "Ticket file":"チケットファイル",
  "Sold out":"完売",
  "Limit tickets per order":"1回の注文につき{num}枚まで",
  "Please select region":"地域を選択してください",
  "Please fill in the correct email address":"正しいメールアドレスを入力してください",
  "Delivery method":"配送方法",
  "E-ticket":"電子チケット",
  "Direct entry":"直接入場",
  "After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher":"支払い成功後、チケットを受け取る必要はなく、チケットフォルダーに行って入場証明書を確認してください",
  "Contact person":"連絡先",
  "Name":"名前",
  "Please fill in the contact name":"連絡先の名前を入力してください",
  "Region":"地域",
  "Please enter the mobile number":"携帯電話番号を入力してください",
  "Please fill in the email":"メールアドレスを入力してください",
  "The ticket verification code will be sent to your email via":"チケット検証コードはメールで送信されます",
  "Details":"詳細",
  "Submit order":"注文を提出",
  "Price details":"価格詳細",
  "The actual discount amount is subject to the following single page":"実際の割引額は以下の注文ページによります",
  "Product information":"商品情報",
  "STAR deduction":"STAR控除",
  "Credit Card":"クレジットカード",
  "Payment Platform":"決済プラットフォーム",
  "On-Chain Payment":"オンチェーン決済",
  "Other":"その他",
  "No refunds":"返金不可",
  "Transferable":"譲渡可能",
  "Not transferable":"譲渡不可",
  "Ended":"終わった",
  "Countdown":"カウントダウン",
  "Please select the ticket file":"チケットファイルを選択してください",
  "Insufficient commodity inventory":"商品の在庫が不足しています",
  "Please go to log in":"ログインしてください",
  "Integral Mall":"インテグラルモール",
  "All Products":"すべての製品",
  "Integral Records":"インテグラルレコード",
  "Transaction Details":"取引の詳細",
  "what": "MUSEとは？",
  "museIntro": "Armonia Meta ChainのARC20トークン。総供給量21億、80%はエコシステムマイニングで流通",
  "museUse": "MUSEの用途",
  "copyrightStaking": "著作権ステーキング",
  "copyrightStaking1": "MUSEをアーティスト著作権NFT（メタバースAI、肖像等）にステークし、収益を分配",
  "vote": "投票権",
  "vote1": "MUSEステークでSTAR NEST WARの追加投票権を獲得",
  "product": "限定商品購入",
  "product1": "限定NFT、グッズ、チケット（早割/VIP）を購入",
  "more": "追加機能（随時更新）",
  "more1": "GameFi: ライセンスゲームでアーティストIP使用、MUSE支払い",
  "more2": "アーティスト支援: MUSEでクリエイターにチップ",
  "activity": "特別イベント",
  "activity1": "限定イベントへの招待権獲得",
  "how": "MUSEの入手方法",
  "how1": "早期プライベートセール参加",
  "how2": "コンテンツ作成で報酬獲得",
  "how3": "イベント（チケット購入、ショッピング）でエアドロップ",
  "how4": "Audition の作品を一部視聴して、楽しみながら稼ぎましょう",
  "Redeem now":"今すぐ引き換える",
  "Basic information":"基本情報",
 }